// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"5e9c7fda","293":"d0c5b7ec","538":"82aeb459","806":"7ae0db28","872":"109c27ba"}[chunkId] + ".chunk.js";
};